export const isInternal = () => !!sessionStorage.getItem("internal");
